<!-- Start Breadcrumbs -->
<app-page-title title="REPORTS.SALEREPORT" [breadcrumbItems]="breadCrumbItems"></app-page-title>
<!-- End Breadcrumbs -->

<div class="row pb-4 gy-3">
    <div class="col-sm-4">
        <div class="d-flex">
            <div class="search-box">
                <input type="text" class="form-control" [placeholder]="'SEARCHFORRESULT' | translate">
                <i class="las la-search search-icon"></i>
            </div>
        </div>
    </div>

    <div class="col-sm-auto ms-auto">
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-soft-primary fs-14"><i
                    class="las la-filter fs-16 align-middle me-2"></i>{{ 'TRANSACTION.FILTER' | translate }}</button>
            <div ngbDropdown>
                <button type="button" id="dropdownMenuLink1" ngbDropdownToggle
                    class="btn btn-soft-info btn-icon fs-14"><i class="las la-ellipsis-v fs-18"></i></button>
                <ul class="dropdown-menu" ngbDropdownMenu>
                    <li><a class="dropdown-item" href="#">{{ 'TRANSACTION.PRINT' | translate }}</a></li>
                    <li><a class="dropdown-item" href="#">{{ 'TRANSACTION.EXPORTTOEXCEL' | translate }}</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-xl-12">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive table-card">
                    <table class="table table-hover table-nowrap align-middle mb-0">
                        <thead>
                            <tr class="text-muted text-uppercase">
                                <th scope="col">{{ 'INVOICES.INVOICEID' | translate }}</th>
                                <th scope="col">{{ 'INVOICES.DATE' | translate }}</th>
                                <th scope="col">{{ 'REPORTS.CATEGORY' | translate }}</th>
                                <th scope="col">{{ 'TARIFFS.PRICE' | translate }}</th>
                                <th scope="col" style="width: 12%;">{{ 'REPORTS.DISCOUNTS' | translate }}</th>
                                <th scope="col" style="width: 12%;">{{ 'TRANSACTION.AMOUNT' | translate }}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let item of paginateData">
                                <td>
                                    <p class="fw-medium mb-0">{{ item.lecId }}</p>
                                </td>
                                <td>{{ item.date }}</td>
                                <td>{{ item.category }}</td>
                                <td>€ {{ item.originalPrice }}</td>
                                <td>{{ item.discount }}</td>
                                <td>€ {{ item.finalPrice }}</td>
                                <td>
                                    <div class="dropdown " ngbDropdown>
                                        <button class="btn btn-soft-secondary btn-sm dropdown" type="button">
                                            <i class="las la-ellipsis-h align-middle fs-18 no-action-btn" ngbDropdownToggle></i>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                            <li>
                                                <button class="dropdown-item" href="javascript:void(0);">
                                                    <i class="las la-eye fs-18 align-middle me-2 text-muted"></i>
                                                  {{ 'DASHBOARD.VIEW' | translate }}
                                                </button>
                                            </li>
                                            <li>
                                                <button class="dropdown-item" href="javascript:void(0);">
                                                    <i class="las la-pen fs-18 align-middle me-2 text-muted"></i>
                                                  {{ 'INVOICES.EDIT' | translate }}
                                                </button>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0);">
                                                    <i
                                                        class="las la-file-download fs-18 align-middle me-2 text-muted"></i>
                                                  {{ 'INVOICES.DOWNLOAD' | translate }}
                                                </a>
                                            </li>
                                            <li class="dropdown-divider"></li>
                                            <li>
                                                <a class="dropdown-item remove-item-btn" href="#">
                                                    <i class="las la-trash-alt fs-18 align-middle me-2 text-muted"></i>
                                                  {{ 'INVOICES.DELETE' | translate }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table><!-- end table -->
                </div><!-- end table responsive -->
            </div>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4 gy-3">
    <div class="col-md-5">
      {{ 'INVOICES.SHOWING' | translate }} <b>{{ startItem + 1 }}</b> {{ 'INVOICES.TO' | translate }} <b>{{ endItem }}</b> {{ 'INVOICES.OF' | translate }} <b>{{ transactions.length }}</b> {{ 'INVOICES.RESULTS' | translate }}
    </div>
    <div class="col-sm-auto ms-auto">
        <pagination class=".pagination-wrap hstack" [totalItems]="transactions.length"
            [itemsPerPage]="itemsPerPage" (pageChanged)="tablepageChanged($event)"></pagination>
    </div>
</div>
